import React from "react";

import HideComponentsByUrlParam from "@gcloud-npm/utils.cms.hide-components-by-url-param";
import COMPONENTS_MAP from "./componentsImports";

export { COMPONENTS_MAP };

class AstroLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAlert: process.env.NEXT_PUBLIC_ENV_NAME !== "prod" };
  }

  render() {
    const { orionInfo, orionAlias, webview = false } = this.props;
    const { showAlert } = this.state;

    const {
      pathname,
      "components-order": componentsOrder,
      "hidden-components": hiddenComponents = [],
    } = orionInfo;

    return (
      <div className={`main-content${webview ? " webview" : ""}`}>
        {componentsOrder &&
          Array.isArray(componentsOrder) &&
          componentsOrder.length > 0 &&
          componentsOrder.map((key) => {
            const baseKey = key.replace(/-\d+$/, ""); // Eliminar el sufijo numérico
            const Component = COMPONENTS_MAP[baseKey];
            // const Component =
            //   COMPONENTS_MAP[baseKey] || COMPONENTS_KEYS[baseKey];
            return (
              Component &&
              orionInfo &&
              orionInfo[key] &&
              !hiddenComponents?.includes(key) && (
                <Component
                  {...orionInfo[key]}
                  blockName={key}
                  key={`cms-component--${key}`}
                  loaded={true}
                  isCms={false}
                  alias={orionAlias}
                />
              )
            );
          })}
        <HideComponentsByUrlParam />
        {/* ALERTA PARA EDITAR EN QA */}
        {showAlert && pathname && (
          <div
            className="astro-sticky-alert"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              width: "24rem",
              position: "fixed",
              bottom: "3rem",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgb(79, 134, 217)",
              borderRadius: "8px",
              padding: "1rem",
              color: "white",
              zIndex: 3,
            }}
          >
            <div
              style={{
                fontSize: "1.5rem",
                flexShrink: 0,
              }}
            >
              ✏️
            </div>

            <div
              className="astro-sticky-alert--text"
              style={{
                flex: 1,
                textAlign: "center",
                lineHeight: 1.4,
              }}
            >
              Para editar el contenido de esta página haga click{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://dev.ssr.col.movistar.es/astro-maker/page/edit/?page=${pathname.replace("/qa", "")}`}
                style={{ color: "white", textDecoration: "underline" }}
              >
                aquí
              </a>
            </div>

            <button
              onClick={() => this.setState({ showAlert: false })}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontSize: "1.2rem",
                cursor: "pointer",
                padding: 0,
                lineHeight: 1,
                flexShrink: 0,
              }}
              aria-label="Cerrar alerta"
            >
              ×
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default AstroLayout;
